import React from "react";
import Phase from '../components/Phase';
import Quote from '../components/Quote';
import alice from '../assets/photos/headshots/m-headshot-alice.png';
export default ({ isActive }) => {
  const message = "When a potential treatment moves into the clinic for the very first time, it enters what we call a Phase I or first-in-human trial. It's an important part of every drug's development because it's the first time it is being given to patients.";
  const quote = {
    author: 'Alice Shaw',
    position: 'Oncologist and Global Head of Translational Clinical Oncology at Novartis',
    img: alice,
    quote: [message]
  }
  const phaseOne = {
    phase: 1,
    title: 'First Tests In Humans',
    parts: '20-100',
    studyLength: 'Several months',
    success: .7
  };

  const utm = 'https://www.novartis.com/clinicaltrials?utm_source=cnn&utm_medium=infographic&utm_campaign=2020-11-clinical-trials-cnn&utm_content=phase-1-link';

  return (
    <div className="component fifth-component">
      <div>
        <Quote quote={quote} isActive={isActive} />
        <Phase {...phaseOne} position="left" utm={utm} />
      </div>
    </div>
  );
};
